import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";

export const SummarizedValidityIndicator = (validationList: any) => {
    if (!validationList) return "-";
    const vList = Object.values(validationList);
    return vList.some((validation: any) => validation.validity === "Not Valid") ? (
      <ErrorIcon sx={{ color: "error.main" }}/>
    ) : vList.some((validation: any) => validation.validity === "Partially Valid") ? (
      <WarningIcon sx={{ color: "warning.main" }}/>
    ) : (
      <CheckCircleIcon  sx={{ color: "success.main" }}/>
    );
  };